<template>
  <div
    v-if="fetcher"
    class="text-center py-[16px]"
  >
    <div
      v-if="fetcher.isLoading && fetcher.data.length > 0"
      ref="loadingFooter"
      class="d-flex justify-content-center align-items-center"
    >
      <b-spinner
        variant="primary"
        label="Loading..."
        small
      />
      <span class="ml-[8px]">Memuat data...</span>
    </div>
    <div
      v-else-if="fetcher.hasMore"
      ref="intersectionFooter"
    />
    <div
      v-else-if="fetcher.data.length > 0 && fetcher.error"
      class="text-center py-[16px] flex items-center justify-center gap-[8px] flex-wrap"
    >
      <span class="text-[#828282]">Terdapat kesalahan saat memuat data</span>
      <b-button
        variant="primary"
        size="sm"
        @click="fetcher.fetchData()"
      >
        Coba lagi
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    fetcher: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      observer: null,
    }
  },
  mounted() {
    this.setupIntersectionObserver()
    this.observeFooter()
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect()
    }
  },
  updated() {
    /** Amati ulang footer saat elemen loading/intersection berubah */
    this.observeFooter()
  },
  methods: {
    /**
     * Siapkan IntersectionObserver untuk infinite scroll
     */
    setupIntersectionObserver() {
      if (!this.observer) {
        this.observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (
                entry.isIntersecting
                    && this.fetcher
                    && this.fetcher.hasMore
                    && !this.fetcher.isLoading
              ) {
                this.fetcher.fetchData()
              }
            })
          },
          {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
          },
        )
      }
      this.observeFooter()
    },
    /**
     * Amati elemen footer intersection; putuskan observer lama sebelum observe ulang
     */
    observeFooter() {
      if (!this.observer) return

      this.observer.disconnect()

      this.$nextTick(() => {
        const footerElement = this.$refs.intersectionFooter
        if (footerElement && this.fetcher && this.fetcher.hasMore) {
          this.observer.observe(footerElement)
        }
      })
    },
  },
}
</script>
